import { createSlice } from '@reduxjs/toolkit';

import { transactionsApi } from 'api/transactions-api';
import { ElectricityCostTransaction, FiatTransaction } from 'types/transactions.types';

export type TransactionsSliceType = {
  fiatTransactions: FiatTransaction[];
  electricityCostTransaction: ElectricityCostTransaction[];
};

export const initialState: TransactionsSliceType = {
  fiatTransactions: [],
  electricityCostTransaction: [],
};

// Populated via extraReducers on the RTK Query fulfilled actions (same pattern as
// features-slice): these feeds are no longer fetched at app startup — the pages that render
// them (MyWallets, Dashboard's RunwayCard) mount the query hooks, and whichever fires first
// fills the slice for every consumer.
const slice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(transactionsApi.endpoints.getFiatTransactions.matchFulfilled, (state, action) => {
      state.fiatTransactions = action.payload;
    });
    builder.addMatcher(transactionsApi.endpoints.getElectricityCostTransactions.matchFulfilled, (state, action) => {
      state.electricityCostTransaction = action.payload;
    });
  },
});

export default slice.reducer;
// selectors
export const fiatTransactionsSelector = (state: { transactions: TransactionsSliceType }) =>
  state.transactions.fiatTransactions;
export const electricityCostTransactionSelector = (state: { transactions: TransactionsSliceType }) =>
  state.transactions.electricityCostTransaction;
